import React, { useEffect, useState } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const NatureContent = ({ data }) => {
    const [limit, setLimit] = useState(15);
    const natures = data.naturesWithMoreAttendances || [];
    const passedLimit = natures.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prev => prev ? null : 15);
    };

    useEffect(() => {
        if (!data?.naturesWithMoreAttendances) return;
        const sorted = [...data.naturesWithMoreAttendances].sort((a, b) => b.qty - a.qty);

        const valuesExtended = sorted.map(item => ([
            item.qty,
            `${item.percent}%`,
            ReportUtils.formatText(item.nature),
            ReportUtils.formatText(item.nature_group)
        ]));

        ReportUtils.createExportableTable(["Quantidade", "Representação", "Natureza", "Grupo"], valuesExtended, "Atendimentos por natureza");

    }, [data]);

    return (
        <div className="mt-4">
            <span className="chart-title mb-2">Atendimentos por natureza {(passedLimit && limit) ? ' (TOP 15)' : ''}</span>
            <table id="attendancesByNatureData" className="table mt-2" sheet-name="Atendimentos por natureza">
                <thead className="thead-background">
                    <tr className="text-left">
                        <th className="w-[10%]">Quantidade</th>
                        <th className="w-[15%]" title="Porcentagem do total das naturezas">Representação</th>
                        <th className="w-[42%]">Natureza</th>
                        <th className="w-[42%]">Grupo</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        (limit ? natures.slice(0, limit) : natures).map((element, index) => (
                            <tr key={index}>
                                <td className="bg-white">{element.qty}</td>
                                <td className="bg-white">{element.percent}%</td>
                                <td className="bg-white">{ReportUtils.formatText(element.nature)}</td>
                                <td className="bg-white">{ReportUtils.formatText(element.nature_group)}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>

            { passedLimit &&
                <div className="text-end mt-1">
                    <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
                </div>
            }

        </div>
    );
};

export default NatureContent;